import PortalRequestsListView from "../../components/portal/PortalRequestsListView";

const PortalContracts = () => {
    return (
        <>
            <section className="home__query">
                <div className="home__query__content wrap">
                    <PortalRequestsListView
                        stageGroups={[
                            {
                                label: "Contract Stages",
                                stages: ["Contract requested", "Contract sent", "Contract signed"],
                            },
                            {
                                label: "Payment Stages",
                                stages: ["Payment initiated", "Payment received"],
                            },
                        ]}
                    />
                </div>
            </section>
        </>
    );
};

export default PortalContracts;
